import {
    UPDATE_EVENTCONFIG_DETAIL,
  } from "../actions/eventConfigEdit";
  
  const defVal = {
    eventConfigDetail: {
          //产品ID
          productId: "",
          //领域ID
          dId: "",
          //事件key
          eKey: "",
          //消息分类
          eCategory: "",
          //事件名称
          eName: "",
          //是否提醒用户 不提醒：NO 提醒：YES
          eNotice: "YES",
          //消息类型 信息类：text 视频类：video
          eMsgType: "text",
          //客户端入口 告警：alarm 通知：notice
          eClientEntrance: "notice",
          //消息Code
          eCode: "",
          //事件推送文案
          ePush: "",
          //事件推送文案(中文)
          ePushCh: "",
          //事件推送文案(英文)
          ePushEn: "",
          //消息列表文案
          eList: "",
          //消息列表文案(中文)
          eListCh: "",
          //消息列表文案(英文)
          eListEn: "",
          //消息详情文案
          eDetail: "",
          //消息详情文案(中文)
          eDetailCh: "",
          //消息详情文案(英文)
          eDetailEn: "",                    
          //RN/H5链接(推送)
          eRhPush: "",
          //RN/H5链接(消息列表)
          eRhList: "",
          //默认图片
          ePicurl: "",
          //上报频率控制
          eReportInterval: 1,
          //存储生命周期
          eStorageCycle: 7,
          //推送间隔
          ePushInterval: 1
    },
    hasData: 'yes',

  };
  
  export default (state = defVal, action) => {
    switch (action.type) {
      case UPDATE_EVENTCONFIG_DETAIL:
        return Object.assign({}, state, {
          eventConfigDetail: action.eventConfigDetail,
          hasData: action.hasData,
        });
      default:
        return state;
    }
  };
  